import { networks } from "bitcoinjs-lib";

export const DEFAULT_NETWORK = networks.bitcoin;
export const DEFAULT_SCRIPT_TYPE = "p2wpkh" as const;
